import { DividerContainer, DividerContent, DividerElement } from './style';

export type DividerDirection = 'vertical' | 'horizontal';
export type BorderStyle = 'solid' | 'dotted';
export type DividerSize = 'default' | 'large';

type DividerProps = {
    children?: React.ReactNode;
    direction?: DividerDirection;
    presentational?: boolean; // Add option to make it purely presentational for a11y
} & ({ size: DividerSize; borderStyle?: Extract<BorderStyle, 'solid'> } | { size?: never; borderStyle?: BorderStyle });

export const Divider = ({
    children,
    size = 'default',
    direction = 'horizontal',
    borderStyle = 'solid',
    presentational = true,
    ...other
}: DividerProps) => {
    const accessibilityProps = presentational
        ? { role: 'none' }
        : {
              role: 'separator',
              'aria-orientation': direction,
          };

    return (
        <DividerContainer data-test-divider direction={direction} {...accessibilityProps} {...other}>
            <DividerElement direction={direction} size={size} borderStyle={borderStyle} />
            {children ? (
                <>
                    <DividerContent>{children}</DividerContent>
                    <DividerElement direction={direction} size={size} borderStyle={borderStyle} />
                </>
            ) : null}
        </DividerContainer>
    );
};
